import { CrossIcon } from '@mentimeter/ragnar-visuals';
import { useEffect, useRef, type PropsWithChildren } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';

interface IdentityListModalProps {
  onDismiss: () => void;
}

export const IdentitiesListModal = ({
  onDismiss,
  children,
}: PropsWithChildren<IdentityListModalProps>) => {
  const identitiesModalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (identitiesModalRef.current) {
      // Focus the modal when it's opened
      identitiesModalRef.current.focus();
    }
  }, []);

  return (
    <Box
      position="fixed"
      right="0"
      mr="space20"
      zIndex={2}
      tabIndex={-1} // Make the modal focusable
      ref={identitiesModalRef}
      onBlur={onDismiss} // Close the modal when it loses focus
    >
      {children}
      <Clickable
        onClick={onDismiss}
        position="absolute"
        top="0"
        right="0"
        p="space8"
      >
        <CrossIcon color="text" />
      </Clickable>
    </Box>
  );
};
